import React from 'react';
import { Text, Layout } from '@oneaudi/unified-web-components';
import { useI18n } from '@oneaudi/i18n-context';
import styled from 'styled-components';
import { SYS_SPACE_FIXED_50 } from '@oneaudi/unified-web-common';
import mapContext from '../../../contexts/map-context';
import { messages } from '../../../i18n/messages';
import { SearchRadiusDropdown } from './SearchRadiusDropdown';

const getMessageAmount = (showRadius: boolean, searchRadiusOptions: number[]) => {
  if (showRadius) {
    if (searchRadiusOptions.length > 1) {
      return messages.search_result_description_with_radius_and_options;
    }

    return messages.search_result_description_with_radius;
  }

  return messages.search_result_description;
};

export const SearchResultsAmount = () => {
  const {
    searchRadius,
    searchRadiusExtended,
    searchRadiusOptions,
    showRadius,
    results,
    distanceUnit,
  } = mapContext.useMapState();

  const messageAmount = getMessageAmount(showRadius, searchRadiusOptions);

  const messageAmountParams = {
    resultCount: results ? results.length : 0,
    radius: `${searchRadius} ${distanceUnit}`,
  };

  const numOfResults = useI18n(messageAmount, messageAmountParams);
  const radiusExtended = useI18n(messages.search_result_radius_extended);

  return (
    <Div>
      {searchRadiusExtended ? (
        <TextContainer>
          <Text
            tag="p"
            variant={{ order: '1', style: 'normal', type: 'copy' }}
            data-test-id="results-list-search-radius-extended"
          >
            {radiusExtended}
          </Text>
        </TextContainer>
      ) : (
        <TextContainer>
          <Text
            tag="p"
            variant={{ order: '1', style: 'normal', type: 'copy' }}
            data-test-id="results-list-search-amount"
            margin={['0', '0', '12px', '0']}
          >
            {numOfResults}
          </Text>
        </TextContainer>
      )}

      {showRadius && searchRadiusOptions.length > 1 && <SearchRadiusDropdown />}
    </Div>
  );
};

const TextContainer = styled.div`
  display: grid;
  align-content: center;
  p {
    margin: 0;
  }
`;

const Div = styled(Layout)`
  padding-top: 1px;
  display: inline-flex;
  justify-content: space-between;
  width: 100%;
  gap: ${SYS_SPACE_FIXED_50};
`;
